import styled from 'styled-components/macro';
import Button from '@material-ui/core/Button';


export const Container = styled.div`
    display:flex;
    margin: 3rem auto;

    @media(max-width: 390px) {
        flex-direction: column;
        align-items: center;
    }
`;

export const Btn = styled(Button) `
    && {
        margin: 0 1rem;
        padding: 0.7rem 1.5rem;
        background-color: #eec653;

        &:hover {
            background-color: #eee6aa;
        }

        @media(max-width: 390px) {
            margin-bottom: 1rem;
        }
    }
`;